module.exports = __webpack_public_path__ + "img/verify.bf9a3b22.png";